"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*eslint-disable react/no-danger*/
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const Banners_1 = require("../../Banners");
const Markdown_1 = __importDefault(require("../../Markdown"));
function EmergencyDisclaimer({ config, onClose, onClick }) {
    const { enabled: showMd, markdown } = config.emergency_disclaimer_md || {};
    const { enabled: showText, text } = config.emergency_disclaimer || {};
    return showMd ? (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(Banners_1.EmergencyBanner, { onClose: onClose },
            react_1.default.createElement(Markdown_1.default, { markdown: markdown, onClick: onClick })))) : showText ? (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(Banners_1.EmergencyBanner, null, text))) : null;
}
exports.default = EmergencyDisclaimer;
//# sourceMappingURL=EmergencyDisclaimer.js.map